import { render, staticRenderFns } from "./caring-circle-profile.vue?vue&type=template&id=19974e30&scoped=true&"
import script from "./caring-circle-profile.vue?vue&type=script&lang=js&"
export * from "./caring-circle-profile.vue?vue&type=script&lang=js&"
import style0 from "./caring-circle-profile.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./caring-circle-profile.vue?vue&type=style&index=1&id=19974e30&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "19974e30",
  null
  
)

export default component.exports